export default {
  styleOverrides: {
    paper: {
      borderRadius: '12px',
    },

    list: {
      padding: '4px',
      gap: '2px',
      display: 'flex',
      flexDirection: 'column',
    }
  },
};
